export function delay(ms) {
    return new Promise((resolve, _) => {
        setTimeout(() => resolve(), ms);
    });
}
